module.exports = __webpack_public_path__ + "img/migration-timer.249ed122.svg";